import { Typography } from "@packages/ds";
import styled from "styled-components";

export const Wrapper = styled.section`
  display: flex;
  flex: 1;
  flex-direction: column;
  padding: 32px;
  margin-bottom: 24px;
  background-color: var(--section-snow-background-color, var(--snow));
  border-radius: 2px;
  position: relative;
`;

export const Header = styled.header`
  display: flex;
`;

export const Title = styled(Typography.Title)<{ isBlackfireCategory: boolean }>`
  margin-right: 16px;
  line-height: 22px;
  margin-bottom: ${({ isBlackfireCategory }) =>
    isBlackfireCategory ? 4 : 22}px;
`;

export const ContainerMultiple = styled.div`
  display: flex;
  flex-direction: column;
`;

export const Link = styled.a`
  text-decoration: none;
`;

export const LinkPointer = styled.a`
  text-decoration: none;
  cursor: pointer;
`;
